import React, { useState, useEffect } from "react";
import API_BASE_URL from "../../../../../../Constants";
import PaginationControls from "../components/PaginationControls";
import DispatchTable from "../components/DispatchTable";
import CallLogForm from "../components/CallLogForm";

const DispatchPage = ({ setMapData, mechanics, latestDispatch, setLatestDispatch }) => {
    const [dispatches, setDispatches] = useState([]);

    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const searchQuery = ""

    const [isLoading, setIsLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingCallLog, setEditingCallLog] = useState(null);

    const handleOpenModal = (callLog) => {
        setIsModalOpen(true);
        setEditingCallLog(callLog);
    }

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setEditingCallLog(null);
    }



    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
        setCurrentPage(1);
    };


    useEffect(() => {
        fetchDispatchedCallLogs(searchQuery, currentPage, rowsPerPage);
    }, [currentPage, rowsPerPage]);


    useEffect(() => {
        if (setMapData) {
            setMapData(dispatches);
        }
    }, [dispatches]);

    useEffect(() => {
        if (latestDispatch) {
            setDispatches(prevDispatches => [latestDispatch, ...prevDispatches]);
            setLatestDispatch(null);
        }
    }, [latestDispatch])

    const fetchDispatchedCallLogs = async (searchQuery, currentPage, rowsPerPage) => {
        try {

            setIsLoading(true);
            // Validate page and size parameters
            const validPage = isNaN(currentPage) || currentPage < 1 ? 1 : currentPage;
            const validSize = isNaN(rowsPerPage) || rowsPerPage < 1 ? 10 : rowsPerPage;

            const queryString = searchQuery ? `&q=${encodeURIComponent(searchQuery)}` : '';

            const response = await fetch(`${API_BASE_URL}/api/callcenter/calllogs/filtered-calllogs/true?&page=${validPage - 1}&size=${validSize}${queryString}`,);
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const data = await response.json();
            setDispatches(Array.isArray(data.content) ? data.content : []);
            setCurrentPage(data.number + 1);
            setTotalPages(data.totalPages);
        } catch (error) {
            console.error("Error fetching call logs:", error);
        }
        finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {

    }, [])


    return (
        <div className="p-6">
            <h2 className="text-2xl font-bold mb-4 border-b-2 border-gray-800 pb-1">
                Dispatches
            </h2>


            {dispatches.length === 0 && !isLoading ? (
                <div className="flex justify-center items-center mt-4">
                    <p className="text-gray-500">No past dispatches found.</p>
                </div>
            ) : (
                <>
                    <div className="flex justify-between items-center p-4 border-t border-gray-300 bg-white">
                        <PaginationControls
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={setCurrentPage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleRowsPerPageChange}
                        />
                    </div>
                    <DispatchTable Dispatches={dispatches} isLoading={isLoading} onEdit={handleOpenModal} />
                </>
            )}


            {isModalOpen && <CallLogForm isOpen={isModalOpen} onClose={handleCloseModal} fetchCallLogs={fetchDispatchedCallLogs} mechanics={mechanics} editingCallLog={editingCallLog} isFollowUp={false} />}
        </div>
    );
};

export default DispatchPage;